import Toast from './Toast';
import { useToast } from '../../context/ToastContext';

export default function ToastContainer() {
  const { toasts, removeToast } = useToast();

  return (
    <div className="fixed bottom-24 xl:bottom-6 left-0 right-0 xl:left-auto xl:right-6 xl:w-80 z-[200] flex flex-col items-center xl:items-end gap-2 px-6 xl:px-0 pointer-events-none" style={{ paddingBottom: 'env(safe-area-inset-bottom, 0px)' }}>
      {toasts.map((toast) => (
        <div key={toast.id} className="pointer-events-auto w-full max-w-sm animate-slide-up">
          <Toast
            id={toast.id}
            message={toast.message}
            type={toast.type}
            duration={toast.duration}
            onClose={removeToast}
          />
        </div>
      ))}
    </div>
  );
}
